import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper.tsx';
import { FormProvider } from 'react-hook-form';
import { useAddOwnerLogic } from '@Pages/happyFlowPages/addOwner/hooks/useAddOwnerLogic.ts';
import { OwnerDetailsForm } from '@Pages/happyFlowPages/addOwner/components/OwnerDetailsForm.tsx';
import { OwnerPersonalDetailsForm } from '@Pages/happyFlowPages/addOwner/components/OwnerPersonalAddressForm.tsx';
import { OwnerIdentityForm } from '@Pages/happyFlowPages/addOwner/components/OwnerIdentityForm.tsx';
import { OwnerAccess } from '@Pages/happyFlowPages/addOwner/components/OwnerAccess.tsx';
import { UboResponse } from '@Store/index';

interface AddOwnerProps {
  ubo?: UboResponse;
}

export const AddOwner = ({ ubo }: AddOwnerProps) => {
  const { t } = useTranslation();

  const { formMethods, isLoading, handleSubmit, onBackClick, isSameAddress, handleOnCheckChange } =
    useAddOwnerLogic(ubo);
  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isLoading}
        handleSubmit={formMethods.handleSubmit(handleSubmit)}
        heading={t('pages.addOwner.title')}
        formMethods={formMethods}
        customBackHandling={onBackClick}
        maxWidth={1100}
        content={''}>
        <div className='flex flex-col tab-landscape:flex-row h-fit gap-0  md:gap-[40px] mt-[24px]'>
          <div className='flex flex-col w-full h-fit'>
            <OwnerDetailsForm />
            <OwnerIdentityForm />
          </div>
          <div className='flex flex-col w-full h-fit'>
            <OwnerPersonalDetailsForm
              disabled={isSameAddress}
              handleOnCheckChange={handleOnCheckChange}
            />
            <OwnerAccess formMethods={formMethods} />
          </div>
        </div>
      </StepPageWrapper>
    </FormProvider>
  );
};
